export default "__VITE_ASSET__nnf$WJSS__"